import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env/environment.local';

@Component({
    selector: 'mc-loading',
    templateUrl: './mc-loading.component.html',
    styleUrls: ['./mc-loading.component.scss'],
})
export class McLoadingComponent implements OnInit {
    assetsUrl: string = environment.assets_url;
    mfsPath: string = environment.mfs_path;
    @Input() overlay = false;
    @Input() fixed = false;
    @Input() label = '';
    @Input() type: 'border' | 'grow' = 'border';
    @Input() size: 'sm' | '' = '';
    @Input() color:
        | 'text-info'
        | 'text-warning'
        | 'text-danger'
        | 'text-success'
        | 'text-light'
        | 'text-dark'
        | 'color-secundario' = 'color-secundario';
    @Input() image: string;
    @Input() useFullSize: boolean = false;
    @Input() animateImage: boolean = false;

    constructor() {}

    ngOnInit() {
        if (this.fixed) {
            this.overlay = true;
        }
    }
}
